var isUrlAbsolute = function isUrlAbsolute(url) {
  return /^(https|http):\/\/|blob:|data:/.test(url);
};

export default isUrlAbsolute;